(() => {
'use strict';
if(window.AUVENNEJourney)return;
window.AUVENNEJourney=true;
const behavior=()=>matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';
function bind(scope=document){
 scope.querySelectorAll('.auv-swipe-rail:not([data-journey-bound])').forEach(rail=>{
  rail.dataset.journeyBound='true';
  const owner=rail.closest('section'),back=owner.querySelector('[data-auv-rail-back]'),next=owner.querySelector('[data-auv-rail-next]');
  const sync=()=>{if(back)back.disabled=rail.scrollLeft<2;if(next)next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
  back?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.85,behavior:behavior()}));
  next?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.85,behavior:behavior()}));
  rail.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(rail);sync();
 });
 scope.querySelectorAll('[data-auv-audit-product]:not([data-journey-bound])').forEach(section=>{
  section.dataset.journeyBound='true';
  const rail=section.querySelector('.auv-product-rail'),figures=[...rail.querySelectorAll('figure')],thumbs=[...section.querySelectorAll('[data-auv-gallery-go]')];
  const form=section.querySelector('[data-auv-picker]'),submit=form.querySelector('[data-auv-submit]')||form.querySelector('button[type=submit]');
  const sticky=section.querySelector('[data-auv-pdp-sticky]'),stickyAction=section.querySelector('[data-auv-pdp-sticky-action]');
  const zoom=section.querySelector('[data-auv-zoom-dialog]'),zoomImage=zoom.querySelector('[data-auv-zoom-image]'),zoomOpen=section.querySelector('[data-auv-zoom-open]');
  let active=figures[0],lastMapping='',frame=0;
  const syncThumbs=()=>{
   const left=rail.getBoundingClientRect().left;
   active=figures.reduce((best,figure)=>Math.abs(figure.getBoundingClientRect().left-left)<Math.abs(best.getBoundingClientRect().left-left)?figure:best,figures[0]);
   thumbs.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.auvGalleryGo===active?.dataset.auvGalleryIndex)));
  };
  rail.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;syncThumbs();});},{passive:true});
  const updateSticky=()=>{
   if(!submit)return;
   const blocked=!!document.querySelector('dialog[open],cart-drawer.active,[data-auv-search-dialog][open]');
   sticky.hidden=!matchMedia('(max-width:749px)').matches||submit.getBoundingClientRect().bottom>0||blocked;
   stickyAction.textContent=submit.textContent;stickyAction.disabled=submit.disabled;
  };
  stickyAction.addEventListener('click',()=>{
   if(submit.dataset.blocked==='true'){form.scrollIntoView({block:'center',behavior:behavior()});form.requestSubmit();}
   else form.requestSubmit();
  });
  const watcher=new IntersectionObserver(updateSticky,{threshold:[0,1]});if(submit)watcher.observe(submit);
  window.addEventListener('resize',updateSticky);window.addEventListener('scroll',updateSticky,{passive:true});
  document.addEventListener('auvenne:cart-synced',updateSticky);
  new MutationObserver(updateSticky).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','class']});
  zoomOpen.hidden=false;
  zoomOpen.addEventListener('click',()=>{
   syncThumbs();const source=active?.querySelector('[data-auv-mapped-photo]')||active?.querySelector('img');
   if(!source)return;
   zoomImage.src=source.currentSrc||source.src;zoomImage.alt=source.alt;
   zoom.showModal();zoom.querySelector('button').focus();updateSticky();
  });
  zoom.querySelector('[data-auv-zoom-close]').addEventListener('click',()=>zoom.close());
  zoom.addEventListener('close',()=>{zoomOpen.focus({preventScroll:true});updateSticky();});
  zoom.addEventListener('click',event=>{if(event.target!==zoom)return;const r=zoom.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)zoom.close();});
  section.addEventListener('auvenne:variant-changed',event=>{
   updateSticky();
   const mapping=event.detail.mapping;
   if(!mapping?.exact||!mapping.primary){figures[0]?.querySelector('[data-auv-mapped-photo]')?.remove();lastMapping='';return;}
   if(mapping.primary===lastMapping)return;
   lastMapping=mapping.primary;
   let photo=figures[0]?.querySelector('[data-auv-mapped-photo]');
   if(!photo&&figures[0]){photo=document.createElement('img');photo.dataset.auvMappedPhoto='';photo.className='auv-pdp-colour-main';photo.width=1200;photo.height=1500;figures[0].append(photo);}
   if(photo){photo.src=mapping.primary;photo.alt=mapping.alt||section.querySelector('h1').textContent;rail.scrollTo({left:0,behavior:behavior()});}
  });
  syncThumbs();updateSticky();
 });
}
const start=()=>bind();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',event=>bind(event.target));
})();
